import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateDocumentTypeModel,
  DeleteDocumentTypeModel,
  SearchDocumentTypeModel,
} from '../../../models/document-type.model'
import { SearchTaxDocumentTypeModel } from '../../../models/tax-document-type.model'

@Injectable({
  providedIn: 'root',
})
export class MessageTypeService {
  private baseUrl = environment.baseUrl
  private resourceType: string = 'mensagem-template/tipos'

  constructor(private httpClient: HttpClient) {}

  public createMessageType(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}`,
      model,
    )
  }

  public editMessageType(
    model: any,
    // model: EditDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/${model.id}`,
      model,
    )
  }

  public deleteMessageType(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.delete<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/${id}`
    )
  }

  public listPagedMessageType(
    page?: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}`,
    )
  }

  public listMessageType(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}`,
    )
  }

  public getDocumentTypebyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/${id}`,
    )
  }

  public searchPagedDocumentType(
    page: number,
    rows: number = 15,
    model: SearchDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
